module.exports = __webpack_public_path__ + "static/work51-57ef0784ef9c9b2d4d537dc06f814c31.jpg";